import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaFormsModule, RecaptchaModule, RecaptchaV3Module } from 'ng-recaptcha-2';
import { TrainingEligibilityComponent } from 'src/app/page-components/training-eligibility/training-eligibility.component';
import { LoadingService } from 'src/app/services/loading-service/loading-service.service';
import { LocalizationGuard } from 'src/app/translation/guard/localization.guard';
import { ScrollGuard } from 'src/app/translation/guard/scroll.guard';
import { environment } from '../../environments/environment';
import { FeedbackPanelComponent } from '../components/feedback-panel/feedback-panel.component';
import { SuccessBannerComponent } from '../components/success-banner/success-banner.component';
import { TrainingEligibilityResultComponent } from '../components/training-eligibility-result/training-eligibility-result.component';
import { GlobalModule } from '../global.module';
import { CPOApprovedCoursesComponent } from '../page-components/cpo-approved-courses/cpo-approved-courses.component';
import { SafetyAndPreventionComponent } from '../page-components/safety-and-prevention/safety-and-prevention.component';
import { TrainingProvidersSearchComponent } from '../page-components/training-providers-search/training-providers-search.component';
import { CertificationService } from '../services/certification-service/certification.service';
import { WorkerService } from '../services/worker-service/worker.service';
import { PublicPagesLayoutComponent } from '../layouts/public-pages-layout/public-pages-layout.component';
import { PublicPageBannerComponent } from '../components/public-page-banner/public-page-banner.component';
import { FAQHomeComponent } from '../page-components/faq-home/faq-home.component';
import { ExternalLinkComponent } from '../components/external-link/external-link.component';

const routes: Routes = [{
  path: '', component: PublicPagesLayoutComponent, canActivate: [LocalizationGuard, ScrollGuard], children: [
    { path: 'home', component: SafetyAndPreventionComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: "Homepage.Title" } },
    { path: 'training-providers', component: SafetyAndPreventionComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: "Tab.CPOApprovedCourses" } },
    { path: 'learners', component: SafetyAndPreventionComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: "Tab.Learners" } },
    { path: 'employers', component: SafetyAndPreventionComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: "Tab.Employers" } },
    { path: 'cpo-approved-courses', component: CPOApprovedCoursesComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: "Tab.CPOApprovedCourses" } },
    { path: 'approved-training-providers', component: TrainingProvidersSearchComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: "Tab.ApprovedTrainingProviders" } },
    { path: 'eligibility-checker', component: TrainingEligibilityComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: "Tab.EligibilityChecker" } },
    { path: 'faqs', component: FAQHomeComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: "Tab.FAQs" } },
    { path: 'external-link', component: ExternalLinkComponent, canActivate: [LocalizationGuard, ScrollGuard], data: { title: "Tab.ExternalLinks" } },
   
    { path: '**', redirectTo: 'home' }]
}
]

@NgModule({
  declarations: [
    PublicPagesLayoutComponent,
    PublicPageBannerComponent,
    SafetyAndPreventionComponent,
    CPOApprovedCoursesComponent,
    TrainingProvidersSearchComponent,
    TrainingEligibilityComponent,
    TrainingEligibilityResultComponent,
    FeedbackPanelComponent,
    SuccessBannerComponent,
    FAQHomeComponent,
    ExternalLinkComponent
  ],
  imports: [GlobalModule, RecaptchaModule, RecaptchaFormsModule, RecaptchaV3Module, RouterModule.forChild(routes)],
  providers: [{ provide: 'CertificationService', useClass: CertificationService },
  { provide: 'WorkerService', useClass: WorkerService },
  { provide: 'LoadingService', useClass: LoadingService },
  { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.captchaSiteKey },
  provideZoneChangeDetection()
  ]
})
export class PublicPagesModule { }
